import { render, staticRenderFns } from "./SBTextbox.html?vue&type=template&id=5222b0ce&scoped=true&"
import script from "./SBTextbox.ts?vue&type=script&lang=ts&"
export * from "./SBTextbox.ts?vue&type=script&lang=ts&"
import style0 from "./SBTextbox.css?vue&type=style&index=0&id=5222b0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222b0ce",
  null
  
)

export default component.exports